import { GHLLanguageKeys as o } from "./ghl-ui.es285.js";
import e from "./ghl-ui.es815.js";
const m = {
  name: o.dutch,
  locale: e
};
export {
  m as date_nl
};
